/**
 * Creates a URL for a given page name
 * @param pageName - The name of the page to create a URL for
 * @returns A formatted URL string
 */
export const createPageUrl = (pageName: string): string => {
  return `/${pageName.toLowerCase().replace(/([A-Z])/g, '-$1').replace(/^-/, '')}`;
};

/**
 * Formats a date to a readable string
 * @param date - Date to format
 * @returns Formatted date string
 */
export const formatDate = (date: Date | string): string => {
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

/**
 * Calculates percentage with proper bounds
 * @param current - Current value
 * @param total - Total value
 * @returns Percentage between 0 and 100
 */
export const calculatePercentage = (current: number, total: number): number => {
  if (total === 0) return 0;
  return Math.min(100, Math.max(0, (current / total) * 100));
};